export default __webpack_public_path__ + "static/media/email_icon.01b20535.svg";